/* ============================================================
   PALAMANO — Cambiar de colección sin recargar la página

   Los enlaces del menú son enlaces de verdad, cada colección con su
   URL: eso es lo que hace que Google las vea como páginas distintas y
   que se puedan compartir. Aquí sólo se intercepta el clic para traer
   el contenido nuevo y cambiar la dirección, que es lo que ahorra el
   parpadeo de recargar entera.

   Si algo falla —la red, un formato inesperado— se deja que el enlace
   haga lo de siempre. Nunca se queda a medias.
   ============================================================ */
(() => {
  const MENU = '.pmn-col-cabecera__enlace';
  const cache = new Map();

  const traer = (url) => {
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { headers: { 'X-Requested-With': 'palamano' } })
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
        .catch((e) => { cache.delete(url); throw e; }));
    }
    return cache.get(url);
  };

  const pintar = (html, url, empujar) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nuevo = doc.querySelector('main');
    const main = document.querySelector('main');
    if (!nuevo || !main) return false;

    main.replaceChildren(...nuevo.childNodes);

    /* Los <script> que llegan dentro del HTML no se ejecutan solos al
       insertarlos: hay que volver a crearlos. (Los componentes del tema
       sí se activan al entrar en la página, de eso se encarga el navegador.) */
    main.querySelectorAll('script').forEach((viejo) => {
      const s = document.createElement('script');
      [...viejo.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = viejo.textContent;
      viejo.replaceWith(s);
    });

    document.title = doc.title;
    if (empujar) history.pushState({ pmn: true }, '', url);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    document.dispatchEvent(new CustomEvent('pmn:coleccion', { detail: { url } }));
    return true;
  };

  const navegar = async (url) => {
    const main = document.querySelector('main');
    main.setAttribute('aria-busy', 'true');
    main.classList.add('pmn-cargando');
    try {
      const html = await traer(url);
      if (!pintar(html, url, true)) location.href = url;
    } catch {
      location.href = url;
    } finally {
      main.removeAttribute('aria-busy');
      main.classList.remove('pmn-cargando');
    }
  };

  /* Al pasar el ratón ya se va trayendo: cuando llega el clic suele estar. */
  document.addEventListener('pointerenter', (e) => {
    const a = e.target.closest?.(MENU);
    if (a && a.href) traer(a.href).catch(() => {});
  }, true);

  document.addEventListener('click', (e) => {
    const a = e.target.closest(MENU);
    if (!a) return;

    /* Que siga funcionando abrir en pestaña nueva, con el botón de en medio
       o con cmd/ctrl: eso es del navegador, no nuestro. */
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (new URL(a.href).origin !== location.origin) return;

    e.preventDefault();
    if (a.href === location.href) return;
    navegar(a.href);
  });

  /* Atrás y adelante del navegador */
  window.addEventListener('popstate', async (e) => {
    if (!e.state?.pmn && !document.querySelector('.pmn-col-cabecera')) return;
    try {
      pintar(await traer(location.href), location.href, false);
    } catch {
      location.reload();
    }
  });
})();
